<div class="bolide-loader-container">
    <div class="random-loader" role="status" aria-live="polite">
        <div class="random-loader-orbit">
            <span></span>
            <span></span>
            <span></span>
        </div>
        <p class="random-loader-text">{{ loader_message }}</p>
    </div>
</div>
